import axios from "axios";
import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { SocketContext, TeamContext } from "../../../../context";
import { useCreatePayloadAndJoinLobby } from "../../../../hooks";
import { MainButton } from "../../../atoms";

interface IJoiningInitially {
    loginData: any;
    isDisabled: boolean;
}

const JoiningInitially: FC<IJoiningInitially> = ({loginData, isDisabled}) => {
	const { t } = useTranslation();
    const { roomUsers, setIsTheButtonClickedToJoinTheGame, urlToken } = useContext(TeamContext);
    const [createPayloadAndJoinRandomLobby] = useCreatePayloadAndJoinLobby(loginData);
    let history = useHistory();
	const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    const urlTokenExtracted = urlPathChunks[urlPathChunks.length-1];
	const { socket } = useContext(SocketContext);

	// should write this nicer

	const handleLogIn = () => {
		axios({
			method: "get",
			url: process.env.REACT_APP_BACKEND_URL + `api/matches/is-game-running/${urlTokenExtracted}`,
		})
		.then((res: any) => {
			if (res.data.isGameRunning) {
				let payload = {
					matchId: urlTokenExtracted,
					gameId: 1,
					player: {
						email: loginData?.email,
						fullName: loginData?.fullName,
						nickname: loginData?.nickname
					}
				};
				localStorage.setItem("userEmailInCaseHeLogsOut", loginData?.email);
		
				socket?.emit("joinPreLobby", payload);
				history.push(`/slotmachineDemo/${urlTokenExtracted}`);
			} else {
				const { email, fullName, nickname } = loginData;
				const formData = new FormData();
				formData.append("email", email);
				roomUsers();
				createPayloadAndJoinRandomLobby(email, fullName, nickname);
				setIsTheButtonClickedToJoinTheGame(true);
				localStorage.clear();
				localStorage.setItem("userEmailInCaseHeLogsOut", email);
			}
			})
			.catch((err: any) => console.error(err));
		}

    return <MainButton text={t("joinTeamText")} type="big" clickHandler={() => handleLogIn()} disabled={isDisabled} />
}

export default JoiningInitially;